import idp from '../apis/idp.api';
import { IDENTITY_PROVIDERS } from '../types/login.types';
import { AxiosResponse } from 'axios';

export const getDomainIdentityService = (
	domain: string,
): Promise<AxiosResponse<{ provider: IDENTITY_PROVIDERS }>> => {
	return idp.get(`/idp/${domain}`);
};
